import React from "react"
import { connect } from "react-redux"
import { window, document } from "browser-monads"
import GoTrue from "gotrue-js"
// import Link from 'gatsby-link'
import { navigate } from "gatsby"
import Container from "../container"
// import { userInfo } from 'os';
import styles from "./registerForm.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faTimesCircle,
  faPlusCircle,
  faTshirt
} from "@fortawesome/free-solid-svg-icons"
import { Loader } from "./../dashboard/loading"
import Popup from "reactjs-popup"

import { toggleRegisterLoad } from "./../../actions/loaders/toggleRegisterLoad"
import {
  collectNames,
  collectNumbers,
  collectStrings,
  collectShirtSize,
  collectTransportMode,
  regFormHandleMemberCount,
  discardMember,
  collectRaftingDay
} from "./../../actions/registration"

const netlifyIdentity = require("netlify-identity-widget")

const API_URL = process.env.NODE_ENV === "development" ? `http://localhost:9000` : `/.netlify/functions`;

const auth = new GoTrue({
  APIUrl: "https://www.farajaraftingchallenge.org/.netlify/identity",
  audience: "",
  setCookie: false
})

class RegisterForm extends React.Component {
  constructor(data) {
    super(data)
    this.state = {
      user: this.props.user,
      isModalDisabled: false,
      fieldError: null,
      termAccepted: false,
      slots: {
        friday: 11,
        fridayMorning: 11,
        fridayAfternoon: 11,
        saturdayMorning: 11,
        saturdayAfternoon: 11,
        sunday: 11,
        sundayMorning: 11,
        sundayAfternoon: 11

      }
    }
  }

  componentDidMount() {
    const user = auth.currentUser()
    this.setState({ user: user }, () => {
      fetch(`${API_URL}/queryForSlots`)
        .then(res => res.json())
        .then(data => {
          this.setState(
            {
              slots: {
                friday: parseFloat(data.data[1][0]),
                fridayMorning: parseFloat(data.data[1][1]),
                fridayAfternoon: parseFloat(data.data[1][2]),
                saturdayMorning: parseFloat(data.data[1][3]),
                saturdayAfternoon: parseFloat(data.data[1][4]),
                sunday: parseFloat(data.data[1][5]),
                sundayMorning: parseFloat(data.data[1][6]),
                sundayAfternoon: parseFloat(data.data[1][7])

              }
            })
        })
        .catch(err => {

        })
    })
  }

  computeNumericNameForMemberHeader = num => {
    if (num === 1) return "1st"
    else if (num === 2) return "2nd"
    else if (num === 3) return "3rd"
    else if (num === 4) return "4th"
    else return ""
  }

  reduxHandleNameChange = (name, type, char, index) => {
    this.props.collectNames(name, type, char, index)
  }

  reduxHandleNumberChange = (name, type, num, index) => {
    this.props.collectNumbers(name, type, num, index)
  }

  reduxHandleStringChange = (name, type, str, index) => {
    this.props.collectStrings(name, type, str, index)
  }

  reduxHandleRadioChange = (name, type, opt, index) => {
    this.props.collectShirtSize(name, type, opt, index)
  }

  reduxHandleSelectChange = (name, type, opt, index) => {
    this.props.collectTransportMode(name, type, opt, index)
  }

  reduxDiscardMember = index => {
    let remainderMemberCount = Object.keys(
      this.props.registerForm.teamMembers
    ).reduce((acc, item) => {
      if (this.props.registerForm.teamMembers[item].firstName.length > 0)
        acc += 1
      return acc
    }, 0)
    this.props.discardMember(index)
    this.props.regFormHandleMemberCount(false, remainderMemberCount)
  }

  reduxBuildMemberTags = total => {
    let tags = Object.keys(this.props.registerForm.teamMembers).map(
      position => {
        if (this.props.registerForm.teamMembers[position].firstName.length > 0)
          return (
            <div
              key={position}
              className="badge mr-3 mt-2"
              style={{ backgroundColor: "#E4419E", color: "#fff", padding: 8 }}
            >
              <span
                style={{ fontSize: 23 }}
              >{`${this.props.registerForm.teamMembers[position].firstName} ${this.props.registerForm.teamMembers[position].lastName}`}</span>
              <FontAwesomeIcon
                icon={faTimesCircle}
                className="ml-2"
                style={{ marginBottom: 2 }}
                onClick={() =>
                  this.reduxDiscardMember(parseFloat(position) + 1)
                }
              />
            </div>
          )
      }
    )
    return tags.map(
      (item, index) =>
        item !== "" &&
        item !== null &&
        item !== undefined && <li key={index}>{item}</li>
    )
  }

  asyncForEach = async (arr, cb) => {
    for (let index = 0; index < arr.length; index++) {
      await cb(arr[index], index, arr)
    }
  }

  getSlotKey = (day, time) => {
    if (!day || !time) return null
    if (day.includes("Friday")) {
      if (time === "Morning") return "fridayMorning"
      if (time === "Afternoon") return "fridayAfternoon"
      return "friday"
    }
    if (day.includes("Saturday")) {
      if (time === "Morning") return "saturdayMorning"
      if (time === "Afternoon") return "saturdayAfternoon"
      return "saturday" // fallback
    }
    if (day.includes("Sunday")) {
      if (time === "Morning") return "sundayMorning"
      if (time === "Afternoon") return "sundayAfternoon"
      return "sunday"
    }
    return null
  }

  handleFormDataEncode = data =>
    Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&")

  saveTeamLeaderData = (data, time, uid, members) => {
    let additionalFields = {
      approved: !false && "Pending",
      createdAt: time,
      isTeamLeader: true && "Yes",
      memberId: `${uid}-1`,
      teamId: uid,
      editable: "Yes",
      teamEditable: "Yes"
    }
    let teamLeader = { ...data, ...additionalFields }
    fetch(
      `${API_URL}/saveNewTeam?${this.handleFormDataEncode(
        teamLeader
      )}`
    )
      .then(res => {
        if (!res.ok) {
          this.props.toggleRegisterLoad(false)
          throw new Error("Slot full")
        }
        return res.json()
      })
      .then(res => {
        const saveTeamMembersSync = async () => {
          await this.asyncForEach(members, async (member, ind) => {
            let { id, ...pureMember } = member
            let { isTeamLeader, ...fields } = additionalFields
            let modifiedMember = {
              ...pureMember,
              ...fields,
              memberId: `${uid}-${ind + 2}`,
              isTeamLeader: !false && "No",
              targetAmount: data.targetAmount,
              teamName: data.teamName,
              organisation: data.organisation,
              raftingDay: data.raftingDay,
              raftingTime: data.raftingTime,
              editable: "Yes",
              teamEditable: "Yes"
            }
            await fetch(
              `${API_URL}/saveNewTeam?${this.handleFormDataEncode(
                modifiedMember
              )}`
            )
              .then(res => res.json())
              .then(res => res)
              .catch(err => {
                console.error("Error saving team member:", err)
                this.props.toggleRegisterLoad(false)
              })
            if (ind === members.length - 1) {
              ////Last index, hide loader & navigate away to team leader dashboard!!
              navigate("/team/")
              this.props.toggleRegisterLoad(false)
            }
          })
        }
        saveTeamMembersSync()
      })
      .catch(err => {
        console.error("Registration error:", err)
        this.props.toggleRegisterLoad(false)
      })
  }

  saveToSheets = (data, uid) => {
    let creationTime = `${new Date().toDateString()} ${new Date().toLocaleTimeString()}`
    this.saveTeamLeaderData(
      data.teamLeader,
      creationTime,
      uid,
      data.teamMembers
    )
  }

  componentWillMount() {
    document.addEventListener("mousedown", this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick, false)
  }

  handleClick = (e, flag) => {
    if (this?.node?.contains(e?.target) && !flag) {
      if (this.state.isModalDisabled) this.setState({ isModalDisabled: false }) //click is inside modal i.e don't close it
      return
    }
    if (!this.state.isModalDisabled) this.setState({ isModalDisabled: true }) //do whatever i.e. close modal
  }

  render() {
    const { user } = this.state
    return (
      <Container>
        <div className={styles.registerForm} ref={node => (this.node = node)}>
          <React.Fragment>
            <div className="row justify-content-inbetween">
              <div className="col-md-7">
                <h3>Please create a team</h3>
              </div>
              {user && (
                <div className="col-md-5">
                  <span style={{ display: "flex", flexDirection: "row" }}>
                    <span className="profile_pic ml-3"></span>
                    <span className="mr-3">Logged in as {user.email} </span>
                    <a
                      onClick={() => netlifyIdentity.open("signup")}
                      style={{
                        color: "#e4419e",
                        cursor: "pointer",
                        textDecoration: "underline"
                      }}
                    >
                      Logout
                    </a>
                  </span>
                </div>
              )}
            </div>
            <br />
            <h4 style={{ textAlign: "left", fontWeight: "bold", color: "#E4419E" }}>Please note, a team is only confirmed as registered, once Faraja approves the team submission.</h4>
            <React.Fragment>
              <h3>Step 1 - Fill in your personal details</h3>

              <form
                name="teams"
                method="POST"
                data-netlify-honeypot="bot-field"
                data-netlify="true"
              >
                <div className="form-group">
                  <label>Team Name</label>
                  <input
                    className="form-control"
                    type="text"
                    name="teamName"
                    maxLength={30}
                    value={this.props.registerForm.teamLeader.teamName}
                    onChange={str =>
                      this.reduxHandleStringChange(
                        "TEAM_NAME",
                        "TEAM_LEADER",
                        str.target.value
                      )
                    }
                  ></input>
                </div>

                <div className="form-group">
                  <label>Organisation</label>
                  <input
                    className="form-control"
                    type="text"
                    name="organisation"
                    maxLength={30}
                    value={this.props.registerForm.teamLeader.organisation}
                    onChange={str =>
                      this.reduxHandleStringChange(
                        "ORGANISATION",
                        "TEAM_LEADER",
                        str.target.value
                      )
                    }
                  ></input>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label>Team Leader's First name</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={char =>
                        this.reduxHandleNameChange(
                          "FIRST_NAME",
                          "TEAM_LEADER",
                          char.target.value
                        )
                      }
                      value={this.props.registerForm.teamLeader.firstName}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label>Team Leader's Last name</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={char =>
                        this.reduxHandleNameChange(
                          "LAST_NAME",
                          "TEAM_LEADER",
                          char.target.value
                        )
                      }
                      value={this.props.registerForm.teamLeader.lastName}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label>Team Leader's Mobile number</label>
                    <input
                      className="form-control"
                      type="number"
                      name="targetAmount"
                      value={this.props.registerForm.teamLeader.mobileNumber}
                      onChange={num =>
                        this.reduxHandleNumberChange(
                          "MOBILE_NUMBER",
                          "TEAM_LEADER",
                          num.target.value.replace(/\+|-/gi, "")
                        )
                      }
                    ></input>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label>Team Leader's Email Address</label>
                    <input
                      className="form-control"
                      type="email"
                      name="emailAddress"
                      value={this.props.registerForm.teamLeader.emailAddress}
                      onChange={str =>
                        this.reduxHandleStringChange(
                          "EMAIL_ADDRESS",
                          "TEAM_LEADER",
                          str.target.value
                        )
                      }
                    ></input>
                  </div>
                </div>

                <div
                  className="form-group"
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  <div style={{ flex: 2 }}>
                    <label>Target Amount To Be Raised</label>
                    <input
                      className="form-control"
                      type="number"
                      name="teamName"
                      maxLength={30}
                      value={this.props.registerForm.teamLeader.targetAmount}
                      onChange={num =>
                        this.reduxHandleNumberChange(
                          "TARGET_AMOUNT",
                          "TEAM_LEADER",
                          num.target.value.replace(/\+|-/gi, "")
                        )
                      }
                    ></input>
                  </div>
                  <a
                    className={"btn btn-sm ml-2 mt-4"}
                    href="/fundraising/"
                    target="_blank"
                    style={{ cursor: "pointer", fontSize: 17 }}
                  >
                    How to
                  </a>
                </div>

                {/* Select rafting section */}
                <div className={"row"}>
                  <div className={"col-12"}>
                    <label>Select the rafting day</label>
                  </div>
                </div>

                <div className={"row m-0"} style={{ display: "none" }}>
                  <div className={"col-12 col-md-12"}>


                    <div className={"row"}>
                      <div
                        className={`${styles.rafting_day} col-12 col-md-4 col-sm-12`}
                      >
                        <h3>21st May,
                          <br />
                          (Friday)
                        </h3>
                      </div>
                      <div
                        className={`${styles.rafting_time} ${this.state.slots.friday < 1 && styles.disabled} ${this.props
                          .registerForm.teamLeader.raftingDay ===
                          "Friday, 21st May" && this.props.registerForm.teamLeader.raftingTime === "Full Day" &&
                          styles.selected} col-12 col-md-8`}
                      >
                        <a
                          aria-disabled={this.state.slots.friday < 1}
                          tabIndex={this.state.slots.friday < 1 ? -1 : 0}
                          style={{ pointerEvents: this.state.slots.friday < 1 ? "none" : "auto" }}
                          onClick={() =>
                            this.state.slots.friday > 0 &&
                            this.props.collectRaftingDay(
                              "Friday, 21st May",
                              "Full Day"
                            )
                          }
                        >
                          Full day
                        </a>
                      </div>
                    </div>


                  </div>
                </div>

                {/* Slot For Friday morning and afternoon */}
                <div className={"row m-0"}>
                  <div className={"col-12 col-md-12"}>
                    <div className={"row"}>
                      <div
                        className={`${styles.rafting_day} col-12 col-md-4 col-sm-12`}
                      >
                        <h3>21st May,
                          <br />
                          (Friday)
                        </h3>
                      </div>
                      <div
                        className={`${styles.rafting_time} ${this.state.slots
                          .fridayMorning < 1 && styles.disabled} ${this.props
                            .registerForm.teamLeader.raftingDay ===
                          "Friday, 22nd May" &&
                          this.props.registerForm.teamLeader.raftingTime ===
                          "Morning" &&
                          styles.selected} col-6 col-lg-4 col-md-4 col-sm-6`}
                      >
                        <a
                          aria-disabled={this.state.slots.fridayMorning < 1}
                          tabIndex={this.state.slots.fridayMorning < 1 ? -1 : 0}
                          style={{ pointerEvents: this.state.slots.fridayMorning < 1 ? "none" : "auto" }}
                          onClick={() =>
                            this.state.slots.fridayMorning > 0 &&
                            this.props.collectRaftingDay(
                              "Friday, 21st May",
                              "Morning"
                            )
                          }
                        >
                          Morning
                        </a>
                      </div>
                      <div
                        className={`${styles.rafting_time} ${this.state.slots
                          .fridayAfternoon < 1 && styles.disabled} ${this
                            .props.registerForm.teamLeader.raftingDay ===
                          "Friday, 22nd May" &&
                          this.props.registerForm.teamLeader.raftingTime ===
                          "Afternoon" &&
                          styles.selected} col-6 col-lg-4 col-md-4 col-sm-6`}
                      >
                        <a
                          aria-disabled={this.state.slots.fridayAfternoon < 1}
                          tabIndex={this.state.slots.fridayAfternoon < 1 ? -1 : 0}
                          style={{ pointerEvents: this.state.slots.fridayAfternoon < 1 ? "none" : "auto" }}
                          onClick={() =>
                            this.state.slots.fridayAfternoon > 0 &&
                            this.props.collectRaftingDay(
                              "Friday, 22nd May",
                              "Afternoon"
                            )
                          }
                        >
                          Afternoon
                        </a>
                      </div>
                    </div>


                  </div>
                </div>

                {/* Selct rafting section 2 */}
                <div className={"row m-0"}>
                  <div className={"col-12 col-md-12"}>


                    <div className={"row"}>
                      <div
                        className={`${styles.rafting_day} col-12 col-md-4 col-sm-12`}
                      >
                        <h3>23rd May,
                          <br />
                          (Saturday)
                        </h3>
                      </div>
                      <div
                        className={`${styles.rafting_time} ${this.state.slots
                          .saturdayMorning < 1 && styles.disabled} ${this.props
                            .registerForm.teamLeader.raftingDay ===
                          "Saturday, 23rd May" &&
                          this.props.registerForm.teamLeader.raftingTime ===
                          "Morning" &&
                          styles.selected} col-6 col-lg-4 col-md-4 col-sm-6`}
                      >
                        <a
                          aria-disabled={this.state.slots.saturdayMorning < 1}
                          tabIndex={this.state.slots.saturdayMorning < 1 ? -1 : 0}
                          style={{ pointerEvents: this.state.slots.saturdayMorning < 1 ? "none" : "auto" }}
                          onClick={() =>
                            this.state.slots.saturdayMorning > 0 &&
                            this.props.collectRaftingDay(
                              "Saturday, 22nd May",
                              "Morning"
                            )
                          }
                        >
                          Morning
                        </a>
                      </div>
                      <div
                        className={`${styles.rafting_time} ${this.state.slots
                          .saturdayAfternoon < 1 && styles.disabled} ${this
                            .props.registerForm.teamLeader.raftingDay ===
                          "Saturday, 22nd May" &&
                          this.props.registerForm.teamLeader.raftingTime ===
                          "Afternoon" &&
                          styles.selected} col-6 col-lg-4 col-md-4 col-sm-6`}
                      >
                        <a
                          aria-disabled={this.state.slots.saturdayAfternoon < 1}
                          tabIndex={this.state.slots.saturdayAfternoon < 1 ? -1 : 0}
                          style={{ pointerEvents: this.state.slots.saturdayAfternoon < 1 ? "none" : "auto" }}
                          onClick={() =>
                            this.state.slots.saturdayAfternoon > 0 &&
                            this.props.collectRaftingDay(
                              "Saturday, 22nd May",
                              "Afternoon"
                            )
                          }
                        >
                          Afternoon
                        </a>
                      </div>
                    </div>


                  </div>
                </div>

                {/* SLOt SECTION 3 */}
                <div className={"row m-0"}>
                  <div className={"col-12 col-md-12"}>
                    <div className={"row"}>
                      <div
                        className={`${styles.rafting_day} col-12 col-md-4 col-sm-12`}
                      >
                        <h3>23rd May,
                          <br />
                          (Sunday)
                        </h3>
                      </div>
                      <div
                        className={`${styles.rafting_time} ${this.state.slots
                          .sundayMorning < 1 && styles.disabled} ${this.props
                            .registerForm.teamLeader.raftingDay ===
                          "Sunday, 23rd May" &&
                          this.props.registerForm.teamLeader.raftingTime ===
                          "Morning" &&
                          styles.selected} col-6 col-lg-4 col-md-4 col-sm-6`}
                      >
                        <a
                          aria-disabled={this.state.slots.sundayMorning < 1}
                          tabIndex={this.state.slots.sundayMorning < 1 ? -1 : 0}
                          style={{ pointerEvents: this.state.slots.sundayMorning < 1 ? "none" : "auto" }}
                          onClick={() =>
                            this.state.slots.sundayMorning > 0 &&
                            this.props.collectRaftingDay(
                              "Sunday, 23rd May",
                              "Morning"
                            )
                          }
                        >
                          Morning
                        </a>
                      </div>
                      <div
                        className={`${styles.rafting_time} ${this.state.slots
                          .sundayAfternoon < 1 && styles.disabled} ${this
                            .props.registerForm.teamLeader.raftingDay ===
                          "Sunday, 23rd May" &&
                          this.props.registerForm.teamLeader.raftingTime ===
                          "Afternoon" &&
                          styles.selected} col-6 col-lg-4 col-md-4 col-sm-6`}
                      >
                        <a
                          aria-disabled={this.state.slots.sundayAfternoon < 1}
                          tabIndex={this.state.slots.sundayAfternoon < 1 ? -1 : 0}
                          style={{ pointerEvents: this.state.slots.sundayAfternoon < 1 ? "none" : "auto" }}
                          onClick={() =>
                            this.state.slots.sundayAfternoon > 0 &&
                            this.props.collectRaftingDay(
                              "Sunday, 23rd May",
                              "Afternoon"
                            )
                          }
                        >
                          Afternoon
                        </a>
                      </div>
                    </div>
                  </div>
                </div>


                <div className={"row"}>
                  <div className={"col-12"}>
                    <br />
                    <label>Select Team Leader's T-Shirt Size</label>
                  </div>
                </div>

                <div className={"row"}>
                  <div className={`${styles.custom_radio_button_wrap} col`}>
                    <div className={styles.input_container}>
                      <input
                        id="small"
                        className={styles.radio_button}
                        type="radio"
                        name="radio"
                        value={"S"}
                        checked={
                          this.props.registerForm.teamLeader.shirtSize === "S"
                        }
                        onChange={opt =>
                          this.reduxHandleRadioChange(
                            "SHIRT_SIZE",
                            "TEAM_LEADER",
                            opt.target.value
                          )
                        }
                      />
                      <div className={styles.radio_tile}>
                        <FontAwesomeIcon icon={faTshirt} />
                        <label htmlFor="small" className={styles.radio_tile_label}>
                          Small
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.custom_radio_button_wrap} col`}>
                    <div className={styles.input_container}>
                      <input
                        id="medium"
                        className={styles.radio_button}
                        type="radio"
                        name="radio"
                        value={"M"}
                        checked={
                          this.props.registerForm.teamLeader.shirtSize === "M"
                        }
                        onChange={opt =>
                          this.reduxHandleRadioChange(
                            "SHIRT_SIZE",
                            "TEAM_LEADER",
                            opt.target.value
                          )
                        }
                      />
                      <div className={styles.radio_tile}>
                        <FontAwesomeIcon icon={faTshirt} />
                        <label htmlFor="medium" className={styles.radio_tile_label}>
                          Medium
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className={`${styles.custom_radio_button_wrap} col`}>
                    <div className={styles.input_container}>
                      <input
                        id="large"
                        className={styles.radio_button}
                        type="radio"
                        name="radio"
                        value={"L"}
                        checked={
                          this.props.registerForm.teamLeader.shirtSize === "L"
                        }
                        onChange={opt =>
                          this.reduxHandleRadioChange(
                            "SHIRT_SIZE",
                            "TEAM_LEADER",
                            opt.target.value
                          )
                        }
                      />
                      <div className={styles.radio_tile}>
                        <FontAwesomeIcon icon={faTshirt} />
                        <label htmlFor="large" className={styles.radio_tile_label}>
                          Large
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className={`${styles.custom_radio_button_wrap} col`}>
                    <div className={styles.input_container}>
                      <input
                        id="extraLarge"
                        className={styles.radio_button}
                        type="radio"
                        name="radio"
                        value={"XL"}
                        checked={
                          this.props.registerForm.teamLeader.shirtSize === "XL"
                        }
                        onChange={opt =>
                          this.reduxHandleRadioChange(
                            "SHIRT_SIZE",
                            "TEAM_LEADER",
                            opt.target.value
                          )
                        }
                      />
                      <div className={styles.radio_tile}>
                        <FontAwesomeIcon icon={faTshirt} />
                        <label
                          htmlFor="extraLarge"
                          className={styles.radio_tile_label}
                        >
                          XL
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className={`${styles.custom_radio_button_wrap} col`}>
                    <div className={styles.input_container}>
                      <input
                        id="extraExtraLarge"
                        className={styles.radio_button}
                        type="radio"
                        name="radio"
                        value={"XXL"}
                        checked={
                          this.props.registerForm.teamLeader.shirtSize === "XXL"
                        }
                        onChange={opt =>
                          this.reduxHandleRadioChange(
                            "SHIRT_SIZE",
                            "TEAM_LEADER",
                            opt.target.value
                          )
                        }
                      />
                      <div className={styles.radio_tile}>
                        <FontAwesomeIcon icon={faTshirt} />
                        <label
                          htmlFor="extraExtraLarge"
                          className={styles.radio_tile_label}
                        >
                          XXL
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={"row"}>
                  <div className={"col-12"}>
                    <br />
                    <label>Team Leader's Transport Pickup Spot</label>
                  </div>
                </div>
                <div className="row">
                  <div className={"col-12 col-md-5 "}>
                    <div className={"custom_dropdown"}>
                      <select
                        onChange={opt =>
                          this.reduxHandleSelectChange(
                            "TRANSPORT",
                            "TEAM_LEADER",
                            opt.target.value
                          )
                        }
                        value={this.props.registerForm.teamLeader.transport}
                      >
                        <option value={"None"}>
                          None (I have my own transport)
                        </option>
                        <option value={"Faraja"}>Faraja</option>
                        <option value={"TRM"}>TRM</option>
                        <option value={"Ruiru"}>Ruiru</option>
                      </select>
                    </div>
                  </div>
                </div>

                <br />
                <h3>Step 2 - Add more people to your team</h3>
                <p style={{ textAlign: "left" }}>
                  Your team should have 5 members (including yourself)
                </p>
                {this.props.completedMembers > 1 && (
                  <ol>
                    {this.reduxBuildMemberTags(this.props.completedMembers)}
                  </ol>
                )}
              </form>

              {this.props.completedMembers < 5 && (
                <Popup
                  trigger={
                    <button className={`btn`} style={{ fontSize: 22 }}>
                      {" "}
                      Add member {this.props.completedMembers}
                      <FontAwesomeIcon
                        icon={faPlusCircle}
                        className="ml-2"
                        style={{ marginTop: 4 }}
                      />
                    </button>
                  }
                  modal
                  disabled={this.state.isModalDisabled}
                >
                  <span>
                    <h3>
                      Add{" "}
                      {this.computeNumericNameForMemberHeader(
                        this.props.completedMembers
                      )}{" "}
                      team member
                    </h3>
                    <form>
                      <div className={"row"}>
                        <div className={"col-12"}>
                          <label>Full names</label>
                        </div>
                        <br />
                      </div>

                      <div className="row">
                        <div className="col-12 col-md-6">
                          <div className={styles.form_group}>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="First name"
                              onChange={char =>
                                this.reduxHandleNameChange(
                                  "FIRST_NAME",
                                  `TEAM_MEMBER_${this.props.completedMembers}_FIRST_NAME`,
                                  char.target.value,
                                  this.props.completedMembers
                                )
                              }
                              value={
                                this.props.registerForm.teamMembers[
                                  this.props.completedMembers - 1
                                ].firstName
                              }
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last name"
                            onChange={char =>
                              this.reduxHandleNameChange(
                                "LAST_NAME",
                                `TEAM_MEMBER_${this.props.completedMembers}_LAST_NAME`,
                                char.target.value,
                                this.props.completedMembers
                              )
                            }
                            value={
                              this.props.registerForm.teamMembers[
                                this.props.completedMembers - 1
                              ].lastName
                            }
                          />
                        </div>
                      </div>

                      <div className={"row"}>
                        <div className={"col-12"}>
                          <br />
                          <label>Email adress</label>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="example@gmail.com"
                            value={
                              this.props.registerForm.teamMembers[this.props.completedMembers - 1].emailAddress
                            }
                            onChange={str =>
                              this.reduxHandleStringChange(
                                "EMAIL_ADDRESS",
                                `TEAM_MEMBER_${this.props.completedMembers}_EMAIL_ADDRESS`,
                                str.target.value,
                                this.props.completedMembers
                              )
                            }
                          />
                        </div>
                      </div>

                      <div className={"row"}>
                        <div className={"col-12"}>
                          <br />
                          <label>Phone number</label>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Entire mobile number"
                            value={
                              this.props.registerForm.teamMembers[
                                this.props.completedMembers - 1
                              ].mobileNumber
                            }
                            onChange={num =>
                              this.reduxHandleNumberChange(
                                "MOBILE_NUMBER",
                                `TEAM_MEMBER_${this.props.completedMembers}_MOBILE_NUMBER`,
                                num.target.value.replace(/\+|-/gi, ""),
                                this.props.completedMembers
                              )
                            }
                          />
                        </div>
                      </div>

                      <div className={"row"}>
                        <div className={"col-12"}>
                          <br />
                          <label>Select T-shirt size</label>
                        </div>
                      </div>

                      <div className={"row"}>
                        <div
                          className={`${styles.custom_radio_button_wrap} col`}
                        >
                          <div className={styles.input_container}>
                            <input
                              id="small"
                              className={styles.radio_button}
                              type="radio"
                              name="radio"
                              value={"S"}
                              checked={
                                this.props.registerForm.teamMembers[
                                  this.props.completedMembers - 1
                                ].shirtSize === "S"
                              }
                              onChange={opt =>
                                this.reduxHandleRadioChange(
                                  "SHIRT_SIZE",
                                  `TEAM_MEMBER_${this.props.completedMembers}_SHIRT_SIZE`,
                                  opt.target.value,
                                  this.props.completedMembers
                                )
                              }
                            />
                            <div className={styles.radio_tile}>
                              <FontAwesomeIcon icon={faTshirt} />
                              <label
                                htmlFor="small"
                                className={styles.radio_tile_label}
                              >
                                Small
                              </label>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`${styles.custom_radio_button_wrap} col`}
                        >
                          <div className={styles.input_container}>
                            <input
                              id="medium"
                              className={styles.radio_button}
                              type="radio"
                              name="radio"
                              value={"M"}
                              checked={
                                this.props.registerForm.teamMembers[
                                  this.props.completedMembers - 1
                                ].shirtSize === "M"
                              }
                              onChange={opt =>
                                this.reduxHandleRadioChange(
                                  "SHIRT_SIZE",
                                  `TEAM_MEMBER_${this.props.completedMembers}_SHIRT_SIZE`,
                                  opt.target.value,
                                  this.props.completedMembers
                                )
                              }
                            />
                            <div className={styles.radio_tile}>
                              <FontAwesomeIcon icon={faTshirt} />
                              <label
                                htmlFor="medium"
                                className={styles.radio_tile_label}
                              >
                                Medium
                              </label>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`${styles.custom_radio_button_wrap} col`}
                        >
                          <div className={styles.input_container}>
                            <input
                              id="large"
                              className={styles.radio_button}
                              type="radio"
                              name="radio"
                              value={"L"}
                              checked={
                                this.props.registerForm.teamMembers[
                                  this.props.completedMembers - 1
                                ].shirtSize === "L"
                              }
                              onChange={opt =>
                                this.reduxHandleRadioChange(
                                  "SHIRT_SIZE",
                                  `TEAM_MEMBER_${this.props.completedMembers}_SHIRT_SIZE`,
                                  opt.target.value,
                                  this.props.completedMembers
                                )
                              }
                            />
                            <div className={styles.radio_tile}>
                              <FontAwesomeIcon icon={faTshirt} />
                              <label
                                htmlFor="large"
                                className={styles.radio_tile_label}
                              >
                                Large
                              </label>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`${styles.custom_radio_button_wrap} col`}
                        >
                          <div className={styles.input_container}>
                            <input
                              id="extraLarge"
                              className={styles.radio_button}
                              type="radio"
                              name="radio"
                              value={"XL"}
                              checked={
                                this.props.registerForm.teamMembers[
                                  this.props.completedMembers - 1
                                ].shirtSize === "XL"
                              }
                              onChange={opt =>
                                this.reduxHandleRadioChange(
                                  "SHIRT_SIZE",
                                  `TEAM_MEMBER_${this.props.completedMembers}_SHIRT_SIZE`,
                                  opt.target.value,
                                  this.props.completedMembers
                                )
                              }
                            />
                            <div className={styles.radio_tile}>
                              <FontAwesomeIcon icon={faTshirt} />
                              <label
                                htmlFor="extraLarge"
                                className={styles.radio_tile_label}
                              >
                                XL
                              </label>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`${styles.custom_radio_button_wrap} col`}
                        >
                          <div className={styles.input_container}>
                            <input
                              id="extraExtraLarge"
                              className={styles.radio_button}
                              type="radio"
                              name="radio"
                              value={"XXL"}
                              checked={
                                this.props.registerForm.teamMembers[
                                  this.props.completedMembers - 1
                                ].shirtSize === "XXL"
                              }
                              onChange={opt =>
                                this.reduxHandleRadioChange(
                                  "SHIRT_SIZE",
                                  `TEAM_MEMBER_${this.props.completedMembers}_SHIRT_SIZE`,
                                  opt.target.value,
                                  this.props.completedMembers
                                )
                              }
                            />
                            <div className={styles.radio_tile}>
                              <FontAwesomeIcon icon={faTshirt} />
                              <label
                                htmlFor="extraExtraLarge"
                                className={styles.radio_tile_label}
                              >
                                XXL
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={"row"}>
                        <div className={"col-12"}>
                          <div className={"row"}>
                            <div className={"col-12"}>
                              <br />
                              <label>Pick up spot</label>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 col-md-8">
                              <div className={"custom_dropdown"}>
                                <select
                                  onChange={opt =>
                                    this.reduxHandleSelectChange(
                                      "TRANSPORT",
                                      `TEAM_MEMBER_${this.props.completedMembers}_TRANSPORT`,
                                      opt.target.value,
                                      this.props.completedMembers
                                    )
                                  }
                                  value={
                                    this.props.registerForm.teamMembers[
                                      this.props.completedMembers - 1
                                    ].transport
                                  }
                                >
                                  <option value={"None"}>
                                    None (I have my own transport)
                                  </option>
                                  <option value={"Faraja"}>Faraja</option>
                                  <option value={"TRM"}>TRM</option>
                                  <option value={"Ruiru"}>Ruiru</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={"row"}>
                        <div className={"col-6 col-md-6 text-right"}>
                          <button
                            className={"btn mt-5"}
                            onClick={e => {
                              e.preventDefault()
                              this.handleClick(e, true)
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                        <div className={"col-6 col-md-6"}>
                          <button
                            className={"btn mt-5"}
                            onClick={e => {
                              e.preventDefault()
                              if (
                                this.props.registerForm.teamMembers[
                                  this.props.completedMembers - 1
                                ].firstName !== "" &&
                                this.props.registerForm.teamMembers[
                                  this.props.completedMembers - 1
                                ].lastName !== ""
                              ) {
                                this.handleClick(e, true)
                                this.props.regFormHandleMemberCount(true)
                              }
                            }}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </span>
                </Popup>
              )}
              <br />
              {this.state?.fieldError && (
                <p className="danger">
                  {this.state?.fieldError}
                </p>
              )}
              {this.props.completedMembers > 4 && (
                <div className="terms-and-conditions mt-4 mb-4" style={{ textAlign: 'left', border: '1px solid #ccc', padding: '15px', borderRadius: '8px', background: '#f9f9f9' }}>
                  <h4 style={{ color: '#E4419E' }}>Terms & Conditions</h4>
                  <div style={{ fontSize: '14px', maxHeight: '200px', overflowY: 'auto', marginBottom: '15px' }}>
                    <p><strong>Code of Conduct:</strong> Participants and spectators are expected to conduct themselves in a respectful, responsible, and inclusive manner throughout the event and to follow all safety instructions provided by event organisers and rafting guides.</p>
                    <p><strong>Photography and Recording:</strong> By attending the Faraja White Water Rafting Challenge, participants and spectators consent to being photographed, filmed, or recorded for promotional, and reporting purposes.</p>
                    <p><strong>Privacy:</strong> Any personal information collected during registration will be used solely for event administration, communication, and fundraising-related purposes and will not be shared with third parties without consent, except where required by law.</p>
                    <p><strong>Liability:</strong> While reasonable precautions will be taken to ensure the safety of all attendees, participation in rafting and related activities is at the individual's own risk. Faraja Cancer Support Trust, event partners, and service providers shall not be held liable for any personal injury, loss, damage, or theft incurred during the event.</p>
                  </div>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="termsCheckbox"
                      checked={this.state.termAccepted}
                      onChange={e => this.setState({ termAccepted: e.target.checked })}
                    />
                    <label className="form-check-label" htmlFor="termsCheckbox" style={{ marginLeft: '10px', fontSize: '16px', fontWeight: 'bold' }}>
                      I have read and agree to the Terms & Conditions
                    </label>
                  </div>
                </div>
              )}
              {this.props.completedMembers > 4 && (
                <button
                  className={"btn mt-3"}
                  disabled={!this.state.termAccepted}
                  onClick={e => {
                    e.preventDefault()
                    this.setState({ fieldError: null })
                    const tl = this.props.registerForm.teamLeader
                    if (
                      tl.teamName !== "" &&
                      tl.firstName !== "" &&
                      tl.lastName !== "" &&
                      tl.emailAddress !== "" &&
                      tl.mobileNumber !== "" &&
                      tl.raftingDay !== "" &&
                      tl.raftingTime !== ""
                    ) {
                      const key = this.getSlotKey(tl.raftingDay, tl.raftingTime)
                      if (key && this.state.slots[key] > 0) {
                        this.props.toggleRegisterLoad(true)
                        this.saveToSheets(this.props.registerForm, user.id)
                      }
                    } else {
                      this.setState({ fieldError: "Please fill in all fields" })
                    }
                  }}
                >
                  Complete
                  {this.props.isRegisterLoaderShowing && (
                    <span className={"mt-2 ml-2"}>
                      <Loader color={"#fff"} size={33} />
                    </span>
                  )}
                </button>
              )}

            </React.Fragment>
          </React.Fragment>
        </div>
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  reduxUser: state.user,
  registerForm: state.registerForm,
  completedMembers: state.regMemberCount,
  isRegisterLoaderShowing: state.isRegisterLoaderShowing
})

const mapDispatchToProps = () => {
  return {
    collectNames,
    collectNumbers,
    collectStrings,
    collectShirtSize,
    collectTransportMode,
    regFormHandleMemberCount,
    discardMember,
    collectRaftingDay,
    toggleRegisterLoad
  }
}

export default connect(mapStateToProps, mapDispatchToProps())(RegisterForm)
